<template>
  <section
    v-show="!hideBlock"
    class="osk-seo-links"
  >
    <div class="osk-wrapper">
      <ul class="osk-seo-links__ul">
        <li
          v-for="(item, index) in linksComp"
          :key="index"
          :class="{
            'osk-seo-links__ul-li': true,
            'osk-seo-links__ul-li_one': linksLength === 1,
            'osk-seo-links__ul-li_two': linksLength === 2,
            'osk-seo-links__ul-li_three': linksLength === 3,
            'osk-seo-links__ul-li_four': linksLength === 4,
          }"
        >
          <div class="osk-seo-links__ul-title">
            {{ item.name }}
          </div>

          <ul
            v-if="item.links?.length"
            class="osk-seo-links__links"
          >
            <li
              v-for="(link, index) in item.links"
              :key="index"
              class="osk-seo-links__link"
            >
              <a
                class="osk-seo-links__link-a"
                :href="link.linkUrl || link.url"
                target="_blank"
              >
                {{ link.linkContent || link.text }}
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { LinkGroupDTO, SeoLinkGroupDto } from '~/restAPI/data-contracts';

const props = defineProps<{
  links: LinkGroupDTO[] | SeoLinkGroupDto[]
}>();

const { isDesktop, isMounted } = useUiBreakpoints();
const { isMorePages } = useMorePagesData();

const linksComp = computed(() => {
  if (props.links.length <= 4) {
    return props.links;
  }

  return props.links.slice(0, 4);
});
const hideBlock = computed(() => isMounted.value && !isDesktop.value && isMorePages.value);
const linksLength = computed(() => linksComp.value.length);
</script>

<style lang="scss">
@import "~/assets/scss/settings/index";

.osk-seo-links {
  padding-bottom: 24px;

  @include media-query(lg-and-up) {
    padding-bottom: 76px;
  }

  &__ul {
    margin-bottom: 0px;

    @include media-query(lg-and-up) {
      display: flex;
      margin-bottom: 0;
    }
  }

  &__ul-li {
    padding-top: 24px;

    border-top: 0.5px solid #dbdbdb;

    &:not(:last-child) {
      padding-bottom: 24px;
    }

    @include media-query(lg-and-up) {
      padding-top: 0;
      padding-bottom: 0 !important;
      border-top: 0;

      &_one {
        width: 100%;

        .osk-seo-links__link {
          width: 25%;
        }
      }

      &_two {
        width: 50%;

        .osk-seo-links__link {
          width: 50%;
        }
      }

      &_three {
        width: 25%;

        .osk-seo-links__link {
          width: 100%;
        }

        &:last-child {
          width: 50%;

          .osk-seo-links__link {
            width: 50%;
          }
        }
      }

      &_four {
        width: 25%;

        .osk-seo-links__link {
          width: 100%;
        }
      }
    }
  }

  &__ul-title {
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    margin-bottom: 13px;
  }

  &__links {
    @include media-query(lg-and-up) {
      display: flex;
      flex-wrap: wrap;
    }
  }

  &__link {
    line-height: 20px;

    &:not(:last-child) {
      margin-bottom: 6px;
    }
  }

  &__link-a {
    display: inline-block;
    @include overflow-ellipsis;
    max-width: 100%;

    @include media-query(lg-and-up) {
      padding-right: 16px;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}

.osk-products-filters-block + .osk-seo-links {
  @include media-query(lg-and-up) {
    padding-top: 22px;
  }
}
</style>
